export enum ChartTypesEnum {
    bar,
    column,
    heat,
    line,
    list,
    map,
    pie,
    wordCloud
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ChartTypesToChartIconsMap = new Map<ChartTypesEnum, string>([
    [ChartTypesEnum.bar, 'fa-duotone fa-regular fa-chart-bar'],
    [ChartTypesEnum.column, 'fa-duotone fa-regular fa-chart-column'],
    [ChartTypesEnum.heat, 'fa-duotone fa-regular fa-table-cells-large'],
    [ChartTypesEnum.line, 'fa-duotone fa-regular fa-chart-line'],
    [ChartTypesEnum.list, 'fa-agpr-posts fa-kit-duotone'],
    [ChartTypesEnum.map, 'fa-duotone fa-regular fa-location-dot'],
    [ChartTypesEnum.pie, 'fa-duotone fa-regular fa-chart-pie'],
    [ChartTypesEnum.wordCloud, 'fa-kit-duotone fa-agpr-cloud-list']
]);
